export { Table as default } from './Table';
